import { render, staticRenderFns } from "./EditStatInsp.vue?vue&type=template&id=2467944c"
import script from "./EditStatInsp.vue?vue&type=script&lang=js"
export * from "./EditStatInsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports